import { styled } from '$utils/theme'
import { rem } from 'polished'
import { VisibilityProps, visibilityCss } from '$utils/theme/css'
import { Block } from '../Block'
import { Icon } from '$views/components/Icon'

export const HeaderWrapper = styled(Block)`
  width: 100%;
  height: ${rem(72)};
  border-bottom: solid 1px ${p => p.theme.colors.lightGrey};
  background-color: white;
  position: fixed;
  z-index: 3;
`
export const HeaderDiv = styled(Block)`
  padding: ${p => rem(p.theme.sizes.base)};
  padding-left: ${p => rem(p.theme.sizes.mini)};
  ${p =>
    p.theme.media.onlyMobile`
      padding-bottom: 0;
      height: 50px;
      border-bottom: solid 1px ${p.theme.colors.lightGrey};
    `};
  height: 71px;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 3;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1160px;
  margin: auto;
  left: 0;
  right: 0;
  ${p => p.theme.media.onlyMobile`
    padding-left: ${rem(p.theme.sizes.mini)};
  `};
`

export const HeaderMenu = styled.div.attrs({})<VisibilityProps>`
  ${visibilityCss};
  display: block;
  text-align: right;
  a {
    color: #44749d !important;
    font-size: 14px;
    letter-spacing: 0.26px;
    text-transform: uppercase;
  }
  a:hover {
    color: #149bbb !important;
  }
`

export const ProPremiumIcon = styled(Icon)`
  position: relative;
  top: ${p => rem(p.theme.sizes.mini)};
  ${p => p.theme.media.onlyMobile`
    top: -${rem(p.theme.sizes.tiny)};
  `}
`



// WEBPACK FOOTER //
// ./src/views/components/Layout/FirstLevelHeader/FirstLevelHeader.style.ts